import { render, staticRenderFns } from "./importEditFees.vue?vue&type=template&id=2209c238&scoped=true"
import script from "./importEditFees.vue?vue&type=script&lang=js"
export * from "./importEditFees.vue?vue&type=script&lang=js"
import style0 from "./importEditFees.vue?vue&type=style&index=0&id=2209c238&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2209c238",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2209c238')) {
      api.createRecord('2209c238', component.options)
    } else {
      api.reload('2209c238', component.options)
    }
    module.hot.accept("./importEditFees.vue?vue&type=template&id=2209c238&scoped=true", function () {
      api.rerender('2209c238', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/costManagement/costsFee/cmp/importEditFees.vue"
export default component.exports